import {createContext} from 'react';
const BroadcasterContext = createContext(null);
export default BroadcasterContext;
